import { render, staticRenderFns } from "./b-ticket-trip-details.vue?vue&type=template&id=9410da72&scoped=true"
import script from "./b-ticket-trip-details.vue?vue&type=script&lang=ts"
export * from "./b-ticket-trip-details.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-trip-details.vue?vue&type=style&index=0&id=9410da72&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9410da72",
  null
  
)

export default component.exports